import {Component, Inject, OnInit} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef, MatDialogTitle
} from "@angular/material/dialog";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {NgIf} from "@angular/common";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {ApplicationsService} from "../../core/modules/openapi";
import {HttpResponse} from "@angular/common/http";
import {MatSelectModule} from "@angular/material/select";

@Component({
  selector: 'app-application-document-upload',
  imports: [
    MatButtonModule,
    MatDialogActions,
    MatDialogContent,
    MatFormFieldModule,
    MatInputModule,
    NgIf,
    ReactiveFormsModule,
    MatToolbarModule,
    MatProgressBarModule,
    MatSelectModule,
    MatDialogTitle
  ],
  templateUrl: './application-document-upload.component.html',
  standalone: true,
  styleUrl: './application-document-upload.component.sass'
})
export class ApplicationDocumentUploadComponent implements OnInit {
  form: FormGroup;
  currentFile?: File;
  progress = 0;
  message = '';
  fileName = '';
  uploading = false;

  constructor(
    public dialogRef: MatDialogRef<ApplicationDocumentUploadComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ApplicationDocumentDialogData,
    private readonly formBuilder: FormBuilder, private readonly applicationsService: ApplicationsService
  ) {
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      documentType: [this.data.documentType, [Validators.required]],
      description: [this.data.description, [Validators.required, Validators.minLength(1), Validators.maxLength(50)]],
      fileContent: [null, Validators.required],
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  createClick(): void {
    this.uploading = true;
    this.form.controls['documentType'].markAsTouched();
    this.form.controls['description'].markAsTouched();
    this.form.controls['fileContent'].markAsTouched();

    if (this.form.valid) {
      this.upload();
    }
  }

  selectFile(event: any): void {
    if (event.target.files && event.target.files[0]) {
      const file: File = event.target.files[0];
      this.currentFile = file;
      this.fileName = this.currentFile.name;
    } else {
      this.fileName = '';
    }
  }

  upload(): void {
    this.progress = 0;
    this.message = "";

    if (this.currentFile) {
      this.applicationsService.uploadApplicationDocument(this.data.applicationId, {
        document: {
          documentType: this.form.controls['documentType'].value,
          description: this.form.controls['description'].value,
          fileName: this.currentFile.name,
        }, fileContent: this.currentFile, fileName: this.currentFile.name
      }).subscribe((event: any) => {
          /*if (event.type === HttpEventType.UploadProgress) {
            this.progress = Math.round(100 * event.loaded / event.total);
          } else*/
          if (event instanceof HttpResponse) {
            this.message = event.body.message;
          }
          this.uploading = false;
          this.dialogRef.close(this.form.value);
        },
        (err: any) => {
          this.uploading = false;
          this.progress = 0;

          if (err.error && err.error.message) {
            this.message = err.error.message;
          } else {
            this.message = 'Could not upload the file!';
          }

          this.currentFile = undefined;
          this.dialogRef.close(this.form.value);
        });
    }
  }
}

export interface ApplicationDocumentDialogData {
  applicationId: string;
  documentType: string;
  documentTypes: string[];
  description: string;
}
